// removed by extract-text-webpack-plugin
module.exports = {"MessageInfoName-left":"lveAmiACptjr9hEGgdd6X","MessageInfoName-right":"_1haqRmTEXWykVVvTyP1eWg","MessageInfoAvatar-right":"_2LqrcsMH79pEIsBn8wm1JF","MessageInfoAvatar-left":"wqaa4vzkGysb8UdbJVH-C","meta":"alN5lsphZ2kXBwCzGF_Gb","time":"DYJ25YJBYIzSDWPAQIGr6","metaContent":"_1VQBDqpyx2euaeSXhaSKIl","normal":"_3IKSjm1m5OgVOkOSbOBcO4","NormalBody":"_1yEIq5DfU5XRt6qb7Jpchr","single":"_1tb5kIhOhsX8MWBb98Tlmq","top":"_2cYdiwYTxoOdPZgDG7Pa89","left":"_3Ez5ajw7qL9W7W60uAiQx","bottom":"_2ukPmYADNWIt9xNjhf9GJ7","right":"_3QtJGzDTSpaCFKG5B-UPb6","TextArea":"_1vpNYhBoLxizv3LQV_UdW_"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Conversation/Message/style.css
// module id = 814
// module chunks = 0